
import { Button, Checkbox, Form, Popover, Input, Modal } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './newsentry.css';
import { cancelEdit, deleteNewsEntry, editAttr, save } from './newsentryActions';
import { formItemLayoutWide, getRequiredRule, getDateRule } from '../utils/antUtils';
const { TextArea } = Input;

const FormItem = Form.Item;

class NewsEntryModalComponent extends Component {

  state = {
    confirmDeleteVisible: false
  }

  handleSubmit = (e) => {

    this.props.form.validateFields((errors) => {
      if (errors) {
        return false;
      }

      let form = this.props.form.getFieldsValue();

      this.props.dispatch(save(this.props.edit, form.publishedDateString))
    });
  }

  handleCancel = (e) => {
    this.setState({ confirmDeleteVisible: false });
    this.props.dispatch(cancelEdit());
  }

  deleteConfirmed = () => {
    this.setState({ confirmDeleteVisible: false });
    this.props.dispatch(deleteNewsEntry(this.props.edit.id));
  }

  onChange(event, attr) {
    this.props.dispatch(editAttr(attr, event.target.value));
  }

  onChangeCheckbox(value, attr) {
    this.props.dispatch(editAttr(attr, value));
  }

  render() {

    if (!this.props.edit) {
      return null;
    }


    const tailFormItemLayout = {
      wrapperCol: { xs: { span: 24, offset: 0, }, sm: { span: 20, offset: 4, } }
    };

    const { getFieldDecorator } = this.props.form;

    let confirmPopup = (<div>
      <Button onClick={this.deleteConfirmed}>Ja</Button>
      <Button style={{ marginLeft: 10 }} onClick={() => this.setState({ confirmDeleteVisible: false })}>Nej</Button>
    </div>);

    let footer = this.props.edit.id === -1 ? [] : [<div style={{ float: 'left' }}>
      <Popover visible={this.state.confirmDeleteVisible} placement="topLeft" title={'Är du säker?'} content={confirmPopup} trigger="click">
        <Button type="danger" onClick={() => this.setState({ confirmDeleteVisible: true })} >Radera nyhet</Button>
      </Popover>
    </div>];

    footer.push(<Button key="back" onClick={this.handleCancel}>Avbryt</Button>);
    footer.push(<Button key="submit" type="primary" onClick={this.handleSubmit}>Spara</Button>);

    let isAdd = this.props.edit.id === -1;

    return (

      <Modal
        title='Ny nyhet på startsidan'
        visible={!!this.props.edit}
        onCancel={this.handleCancel}
        maskClosable={false}
        footer={footer}
        width={1200}
      >
        <div>
          <Form onSubmit={this.handleSubmit}>
            <FormItem {...formItemLayoutWide} label="Titel" >
              {getFieldDecorator('title', { rules: [{ required: true, message: 'Ange en titel' }], })(
                <Input autoFocus onBlur={(e) => this.onChange(e, 'title')} />)}
            </FormItem>
            <FormItem {...formItemLayoutWide} label="Publiceringsdatum" >
              {getFieldDecorator('publishedDateString', { rules: [getRequiredRule('Ange ett datum'), getDateRule('Ange ett datum på formatet: 2017-12-24')], })(
                <Input />
              )}
            </FormItem>
            <FormItem {...tailFormItemLayout}>
              {getFieldDecorator('publishedOnStartPage', {
                valuePropName: 'checked'
              })(
                <Checkbox onChange={(e) => this.onChangeCheckbox(e.target.checked, 'publishedOnStartPage')}>Publicerad</Checkbox>
              )}
            </FormItem>
            <FormItem {...tailFormItemLayout}>
              {getFieldDecorator('lawEntry', {
                valuePropName: 'checked'
              })(
                <Checkbox onChange={(e) => this.onChangeCheckbox(e.target.checked, 'lawEntry')}>Lagnyhet (visas endast i nyhetsbrevet)</Checkbox>
              )}
            </FormItem>
            <FormItem {...formItemLayoutWide} label="Sortering nyhestbrev (1,2,3)" >
              {getFieldDecorator('sortOrder', { rules: [], })(
                <Input type="number" autoFocus onBlur={(e) => this.onChange(e, 'sortOrder')} />)}
            </FormItem>

            <FormItem {...formItemLayoutWide} label="Databaser" >
              {getFieldDecorator('dbType', { rules: [{ required: true, message: 'Ange en eller flera databaser' }], })(
                <Input autoFocus onBlur={(e) => this.onChange(e, 'dbType')} />)}
            </FormItem>
            <FormItem {...formItemLayoutWide} label="Innehåll" >
              {getFieldDecorator('content', { rules: [getRequiredRule('Ange ett innehåll')]})(<TextArea style={styles.textArea} rows={25} onBlur={(e) => this.onChange(e, 'content')} />)}
            </FormItem>
          </Form>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    edit: state.newsentry.edit
  }
};


export default connect(mapStateToProps)(Form.create({
  mapPropsToFields(props) {
    return {
      title: Form.createFormField({ value: props.edit ? props.edit.title : '' }),
      sortOrder: Form.createFormField({ value: props.edit ? props.edit.sortOrder : '' }),      
      content: Form.createFormField({ value: props.edit ? props.edit.content : '' }),
      dbType: Form.createFormField({ value: props.edit ? props.edit.dbType : '' }),
      publishedOnStartPage: Form.createFormField({ value: props.edit ? props.edit.publishedOnStartPage : false }),
      lawEntry: Form.createFormField({ value: props.edit ? props.edit.lawEntry : false }),
      publishedDateString: Form.createFormField({ value: props.edit ? props.edit.publishedDateString : '' })
    }
  }
})(NewsEntryModalComponent));



// WEBPACK FOOTER //
// ./src/newsentry/newsentryModalComponent.js